import { browserExtensionClient } from 'clients/BrowserExtensionClient/BrowserExtensionClient';
import { htmlToLinkedInFormat } from 'utils/shared/htmlToLinkedInFormat';

export const sendNewLinkedinInMailMessage = async (params: {
  esPersonIdWithoutPlatform: string;
  subject: string;
  body: string;
  signature: string;
}) => {
  const { esPersonIdWithoutPlatform, subject, body, signature } = params;

  const messageLinkedinFormatted = htmlToLinkedInFormat(body);

  const query = {
    variables: {
      messagePostPayloads: [
        {
          primaryPost: {
            attachments: [],
            richFormattedBody: {
              text: messageLinkedinFormatted.text,
              attributes: messageLinkedinFormatted.attributes,
            },
            channel: 'INMAIL',
            enableCalenderShare: false,
            subject,
          },
          followUpPosts: [],
          ofccpTrackingId: null,
          recipientProfileUrn: `urn:li:ts_profile:${esPersonIdWithoutPlatform}`,
          signature,
          visibility: 'PRIVATE',
        },
      ],
    },
    queryId: 'talentMultiMessagePosts.be0f985141a7cf89d4d410c4e5839e8f',
    includeWebMetadata: true,
  };

  return browserExtensionClient.sendMessage('proxyHttpRequest', {
    url: 'https://www.linkedin.com/talent/api/graphql?action=execute&queryId=talentMultiMessagePosts.be0f985141a7cf89d4d410c4e5839e8f',
    method: 'POST',
    body: JSON.stringify(query),
    addHeadersFrom: 'linkedInClassic',
    headers: {
      accept: 'application/vnd.linkedin.normalized+json+2.1',
    },
  });
};
